import RightPartModal from "./RightPartModal";

export default RightPartModal;
